import { ITranslationEntry } from '../lang';

export const NB: ITranslationEntry = {
  translations: {
    notifications: 'Varsler',
    markAllAsRead: 'Marker alle som lest',
    poweredBy: 'Drevet av',
    settings: 'Innstillinger',
  },
  lang: 'nb',
};
